var consumer = {
  "units": {
    "Wh": {
      "single": "watt-hour",
      "plural": "watt-hours",
      "annotated_abv": "(Wh)",
      "abv": "Wh",
      "definition": "Energy production and usage is measured in watt-hours (Wh). A kilowatt-hour (kWh) is equal to 1,000 watt-hours, and is the unit commonly used by electric utilities on monthly bills."
    },
    "kWh": {
      "single": "kilowatt-hour",
      "plural": "kilowatt-hours",
      "annotated_abv": "(kWh)",
      "abv": "kWh"
    },
    "MWh": {
      "single": "megawatt-hour",
      "plural": "megawatt-hours",
      "annotated_abv": "(MWh)",
      "abv": "MWh"
    },
    "GWh": {
      "single": "gigawatt-hour",
      "plural": "gigawatt-hours",
      "annotated_abv": "(GWh)",
      "abv": "GWh"
    },
    "TWh": {
      "single": "terawatt-hour",
      "plural": "terawatt-hours",
      "annotated_abv": "(TWh)",
      "abv": "TWh"
    },
    "PWh": {
      "single": "petawatt-hour",
      "plural": "petawatt-hours",
      "annotated_abv": "(PWh)",
      "abv": "PWh"
    },
    "EWh": {
      "single": "exawatt-hour",
      "plural": "exawatt-hours",
      "annotated_abv": "(EWh)",
      "abv": "EWh"
    },
    "ZWh": {
      "single": "zettawatt-hour",
      "plural": "zettawatt-hours",
      "annotated_abv": "(ZWh)",
      "abv": "ZWh"
    },
    "YWh": {
      "single": "yottawatt-hour",
      "plural": "yottawatt-hours",
      "annotated_abv": "(YWh)",
      "abv": "YWh"
    },
    "W": {
      "single": "watt",
      "plural": "watts",
      "annotated_abv": "(W)",
      "abv": "W"
    },
    "kW": {
      "single": "kilowatt",
      "plural": "kilowatts",
      "annotated_abv": "(kW)",
      "abv": "kW"
    },
    "MW": {
      "single": "megawatt",
      "plural": "megawatts",
      "annotated_abv": "(MW)",
      "abv": "MW"
    },
    "GW": {
      "single": "gigawatt",
      "plural": "gigawatts",
      "annotated_abv": "(GW)",
      "abv": "GW"
    },
    "TW": {
      "single": "terawatt",
      "plural": "terawatts",
      "annotated_abv": "(TW)",
      "abv": "TW"
    },
    "PW": {
      "single": "petawatt",
      "plural": "petawatts",
      "annotated_abv": "(PW)",
      "abv": "PW"
    },
    "EW": {
      "single": "exawatt",
      "plural": "exawatts",
      "annotated_abv": "(EW)",
      "abv": "EW"
    },
    "ZW": {
      "single": "zettawatt",
      "plural": "zettawatts",
      "annotated_abv": "(ZW)",
      "abv": "ZW"
    },
    "YW": {
      "single": "yottawatt",
      "plural": "yottawatts",
      "annotated_abv": "(YW)",
      "abv": "YW"
    },
    "percent": {
      "single": "percent",
      "plural": "percent",
      "annotated_abv": "%",
      "abv": "%"
    },
    "minutes": {
      "zero": "minutes",
      "ltone": "minute",
      "single": "minute",
      "plural": "minutes"
    },
    "hours": {
      "zero": "hours",
      "ltone": "hour",
      "single": "hour",
      "plural": "hours"
    },
    "months": {
      "zero": "months",
      "ltone": "month",
      "single": "month",
      "plural": "months"
    },
    "years": {
      "zero": "years",
      "ltone": "year",
      "single": "year",
      "plural": "years"
    },
    "days": {
      "zero": "days",
      "ltone": "day",
      "single": "day",
      "plural": "days"
    },
    "nights": {
      "zero": "nights",
      "ltone": "night",
      "single": "night",
      "plural": "nights"
    },
    "batteries": {
      "zero": "batteries",
      "ltone": "battery",
      "single": "battery",
      "plural": "batteries"
    },
    "trees": {
      "zero": "trees",
      "ltone": "tree",
      "single": "tree",
      "plural": "trees"
    },
    "kg": {
      "zero": "kg",
      "ltone": "kg",
      "single": "kg",
      "plural": "kgs"
    },
    "laps": {
      "zero": "laps",
      "ltone": "lap",
      "single": "lap",
      "plural": "laps"
    },
    "barrels": {
      "zero": "barrels",
      "ltone": "barrel",
      "single": "barrel",
      "plural": "barrels"
    },
    "flights": {
      "zero": "flights",
      "ltone": "flight",
      "single": "flight",
      "plural": "flights"
    },
    "launches": {
      "zero": "launches",
      "ltone": "launch",
      "single": "launch",
      "plural": "launches"
    }
  },
  "timeAgo": {
    "now": "Now",
    "second": {
      "single": "1 second ago",
      "plural": "%{number} seconds ago"
    },
    "minute": {
      "single": "1 minute ago",
      "plural": "%{number} minutes ago"
    },
    "hour": {
      "single": "1 hour ago",
      "plural": "%{number} hours ago"
    },
    "day": {
      "single": "1 day ago",
      "plural": "%{number} days ago"
    },
    "week": {
      "single": "1 week ago",
      "plural": "%{number} weeks ago"
    },
    "month": {
      "single": "1 month ago",
      "plural": "%{number} months ago"
    },
    "year": {
      "single": "1 year ago",
      "plural": "%{number} years ago"
    }
  },
  "weather": {
    "unknown": "Weather unknown",
    "footer": "Weather data provided by The Weather Company.",
    "credit": "Provided by The Weather Company"
  },
  "reports": {
    "title": "Reports",
    "submit": "Run Report",
    "to": "to",
    "selectDate": "Select the date",
    "insufficientData": "Please check back tomorrow. Enphase cloud has not collected the required data to create reports.",
    "1": {
      "name": "Daily Production",
      "title": "Site Energy Production",
      "description": "Summary of daily energy production of this site. Since this report provides energy by day, you may request days up until yesterday."
    },
    "2": {
      "name": "Recent Production",
      "title": "Site Recent Power Production",
      "description": "Summary of the last week of power production in 5 minute increments of this site."
    },
    "6": {
      "name": "Monthly Production",
      "title": "Monthly Energy Production",
      "description": "Summary of a month of energy production and peak power of this site."
    },
    "15": {
      "name": "Daily Consumption",
      "title": "Site Energy Consumption",
      "description": "Summary of daily energy consumption of this site. Since this report provides energy by day, you may request days up until yesterday."
    },
    "16": {
      "name": "Recent Consumption",
      "title": "Site Recent Power Consumption",
      "description": "Summary of the last week of power consumption in 15 minute increments of this site."
    },
    "17": {
      "name": "Monthly Net Energy",
      "title": "Monthly Net Energy",
      "description": "This report summarizes the energy produced, consumed, imported to and exported from this site for every 15 minutes of the selected month. If the system includes AC Batteries the report also shows energy stored and discharged."
    },
    "19": {
      "name": "Battery Report",
      "title": "Battery Report",
      "description": "This report provides last 7 days of battery data"
    },
    "3": {
      "name": "Per Module One Day Energy Production",
      "title": "Per Module One Day Energy Production",
      "description": "This report provides energy production of all microinverters for the date specified."
    },
    "5": {
      "name": "Per Module One Month Energy Production",
      "title": "Per Module One Month Energy Production",
      "description": "This report provides energy production of all microinverters for the month specified."
    },
    "20": {
      "name": "IQ-Relay Self-Test Report",
      "title": "IQ-Relay Self-Test results report",
      "description": "This report provides latest IQ-Relay Self-Test results"
    },
    "25": {
      "name": "Custom report (in Wh)",
      "title": "Custom Report",
      "description": ""
    }
  },
  "stats": {
    "total": "Total Energy",
    "peak_production": "Peak Power",
    "latest_production": "Latest Power",
    "peak_consumption": "Peak Consumption",
    "latest_consumption": "Latest Consumption",
    "recent_power": "Recent Power",
    "maintainer": "Contact your maintainer",
    "enphase": "Contact Enphase Support",
    "orenphase": "Or contact Enphase Support",
    "learn_more": "Learn more.",
    "where": "Where's the problem?",
    "toGrid": "Approximately %{value} exported to grid",
    "fromGrid": "Approximately %{value} imported from grid",
    "normal": {
      "title": "Normal",
      "modal": "Your system is operating normally."
    },
    "shortcomm": {
      "title": "Gateway Not Reporting",
      "hours": "Your system hasn't reported data to Enphase cloud for the last %{hours} hours.",
      "date": "Your system hasn't reported data to Enphase cloud since %{date}.",
      "unknown": "This system isn't reporting to Enphase cloud.",
      "question": "Is your internet connection down?",
      "help_topic_link": "Get re-connected to see how your system performed.",
      "link": "Click here for help."
    },
    "meter": {
      "title": "Meter Not Reporting",
      "hours": "Your system's meter hasn't reported to the gateway for the last %{hours} hours.",
      "date": "Your system's meter hasn't reported to the gateway since %{date}.",
      "ct_wiring": "There is an issue with your gateway meter measurements. Contact your maintainer for help.",
      "unknown": "Your system's meter isn't reporting to the gateway.",
      "link": "Click here for help.",
      "modal": "Your meter has not reported data to the gateway since"
    },
    "meter_issue": {
      "title": "Meter Issue",
      "ct_wiring": "There is an issue with your gateway meter measurements",
      "link": "Click here for help."
    },
    "battery": {
      "title": "AC Batteries Not Reporting",
      "modal": "This AC Battery is not reporting data.",
      "message": "Some AC Batteries aren't reporting data.",
      "messageSome": "Some AC Batteries (%{count}) aren't reporting data.",
      "link": "Click here for help."
    },
    "storage_idle": {
      "title": "Storage Inactive",
      "modal": "This AC Battery is not charging or discharging.",
      "date": "At least one AC Battery has not charged or discharged since %{date}.",
      "unknown": "At least one AC Battery is not charging or discharging.",
      "link": "Click here for help."
    },
    "encharge": {
      "title": "Battery Not Reporting",
      "modal": "This battery is not reporting data.",
      "message": "Battery is not reporting data. This can occur if the wireless communication between your gateway and the battery is weak. This may be a temporary glitch and should recover soon.",
      "requestMaintainer": "If the issue persists, please contact your maintainer for help.",
      "messageSome": "Some Batteries (%{count}) aren't reporting data.",
      "link": "Click here for help."
    },
    "enpower": {
      "title": "System controller Not Reporting",
      "modal": "This system controller is not reporting data.",
      "message": "System controller is not reporting data. This can occur if the wireless communication between your gateway and the system controller is weak. This may be a temporary glitch and should recover soon.",
      "requestMaintainer": "If the issue persists, please contact your maintainer for help.",
      "messageSome": "Some system controllers (%{count}) aren't reporting data.",
      "link": "Click here for help."
    },
    "encharge_issue": {
      "title": "Battery Error",
      "modal": "This battery has an error.",
      "message": "Battery has an error."
    },
    "enpower_issue": {
      "title": "System controller Error",
      "modal": "This system controller has an error.",
      "message": "System controller has an error."
    },
    "micro": {
      "title": "Microinverters Not Reporting",
      "modal": "This microinverter is not reporting data to the gateway.",
      "message": "Some microinverters aren't reporting data to the gateway.",
      "messageSome": "Some microinverters (%{count}) aren't reporting data to the gateway.",
      "messageAll": "No microinverters are reporting data to the gateway.",
      "link": "Click here for help."
    },
    "power": {
      "title": "System Production Issue",
      "message": "There is a production issue with your system.",
      "messageSome": "This microinverter is reporting a production issue.",
      "messageThreshold": "Your system is producing less energy than expected.",
      "link": "Contact Enphase Support for help.",
      "maintainerlink": "Contact your maintainer for help."
    },
    "data_upload": {
      "title": "Data upload in progress"
    },
    "span_issue": {
      "title": "Gateway not connected to SPAN panel",
      "message": "Your gateway is not communicating with SPAN panel. If the issue persists, contact SPAN customer support",
      "spanSupport": "SPAN support:"
    }
  }
};
module.exports = consumer;